import React from "react";

import { useContext } from "react";
import { AppContext } from "components/app/RemExprertProvider";
import TextField from "components/ui/controls/text-field/text-field";
import DropDown from "components/ui/controls/drop-down/drop-down";
import "./ContexteFiscal.css";

const PlusMoinsValue=(props)=> {
  const { Outil } = props;
  const context = useContext(AppContext);

  return (
    <div className="revenuspro-container">
      {/* Header séparé */}
      <div className="header-card">
        <div className="category-column">
          <span className="header-icon">📈</span>
          Paramètres des plus et moins values mobilières
        </div>
        <div className="value-column">
          <span className="header-icon">💰</span>
          Montant
        </div>
      </div>

      {/* Conteneur des cartes de contenu */}
      <div className="card-list-container">
        {/* Montant des plus values */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📊</div>
            Montant des plus values
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantPlusValue"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantPlusValue")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Montant des moins values imputables */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📉</div>
            Montant des moins values imputables
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantMoinsValue"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantMoinsValue")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Montant de l'abattement pour durée de détention */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">📅</div>
            Montant de l'abattement pour durée de détention
          </div>
          <div className="value-column">
            <TextField
              value={context.state[Outil + "IRDirigeantAbattementDureeDetention"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantAbattementDureeDetention")}
              dataType="uint"
              format={{ thousands: " ", unit: " €" }}
              normal
            />
          </div>
        </div>

        {/* Abattement spécifique pour départ en retraite */}
        <div className="card">
          <div className="category-column">
            <div className="titre-icone">🎯</div>
            Abattement spécifique pour départ en retraite
          </div>
          <div className="value-column">
            <DropDown
              value={context.state[Outil + "IRDirigeantAbattementDepartRetraite"]}
              onChange={context.handleInputChange(Outil + "IRDirigeantAbattementDepartRetraite")}
              options={[
                { value: "Non", label: "Non" },
                { value: "Oui", label: "Oui" },
              ]}
              normal
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default PlusMoinsValue;
